import FormattedMessage from "@components/UI/FormattedMessage";

const AdditionalBaggageInfoFooter = () => (
  <div className="flight-additional-info-baggage-modal-table-footer ">
    <div>
      (*) <FormattedMessage id="FlightAdditionalInfoBaggage.dimensions" />
    </div>
    <ul className="flight-additional-info-baggage-modal-list">
      <li>
        <strong>
          <FormattedMessage id="FlightAdditionalInfoBaggage.baggage" />
        </strong>{" "}
        <FormattedMessage id="FlightAdditionalInfoBaggage.baggageDescription" />
      </li>
      <li>
        <strong>
          <FormattedMessage id="FlightAdditionalInfoBaggage.handBaggage" />
        </strong>{" "}
        <FormattedMessage id="FlightAdditionalInfoBaggage.handBaggageDescription" />
      </li>
    </ul>
  </div>
);

export default AdditionalBaggageInfoFooter;
